export interface TopicDTO {
  description: [(string | number)[]];
  experts: string[];
  kiosks: string[];
  priority: number;
  title: [(string | number)[]];
}

export interface WebexTokenDTO {
  token_string: string;
  expiration: string;
  jwt: string;
}

export enum ClientStatus {
  failure = -1,
  notConnected,
  unavailable,
  ready,
  busy
}

export enum EndpointStatusDetails {
  disabledSafariMediaInputsAccess = "Disabled Safari Media Inputs Access",
  twilioAccessTokenRetrievingError = "Twilio access token retrieving error",
  webexInitializationError = "Webex initialization error",
  webexMeetingCreatingError = "Webex meeting creating error",
  webexMeetingJoiningError = "Webex meeting joining error",
  webexMeetingReconnectionError = "Webex meeting reconnection error",
  webexMeetingDestroyed = "Webex meeting failed, 'DESTROY_MEETING' event received",
  webexMeetingErrorCallbackHandled = "Webex meeting failed, 'error' meeting handler ran",
  ownWebexPersonRetrievingError = "Own Webex person retrieving error",
  invitingToWebexMeetingError = "Inviting to Webex meeting error",
  mediaStreamsCreatingError = "Can not get media stream(s)"
}

export enum EndpointStatus {
  unknown,
  failure,
  ready,
  inComingCall,
  placingCall,
  connected,
  transferring,
  onHold = 256,
  videoOn = 512
}

export type EndpointStatusDTO = {
  details: EndpointStatusDetails | string;
  extension: string;
  parties: string[];
  status: EndpointStatus | number;
};

export enum Timezone {
  UTC,
  "Africa/Abidjan",
  "Africa/Accra",
  "Africa/Addis_Ababa",
  "Africa/Algiers",
  "Africa/Asmara",
  "Africa/Bamako",
  "Africa/Bangui",
  "Africa/Banjul",
  "Africa/Bissau",
  "Africa/Blantyre",
  "Africa/Brazzaville",
  "Africa/Bujumbura",
  "Africa/Cairo",
  "Africa/Casablanca",
  "Africa/Ceuta",
  "Africa/Conakry",
  "Africa/Dakar",
  "Africa/Dar_es_Salaam",
  "Africa/Djibouti",
  "Africa/Douala",
  "Africa/El_Aaiun",
  "Africa/Freetown",
  "Africa/Gaborone",
  "Africa/Harare",
  "Africa/Johannesburg",
  "Africa/Juba",
  "Africa/Kampala",
  "Africa/Khartoum",
  "Africa/Kigali",
  "Africa/Kinshasa",
  "Africa/Lagos",
  "Africa/Libreville",
  "Africa/Lome",
  "Africa/Luanda",
  "Africa/Lubumbashi",
  "Africa/Lusaka",
  "Africa/Malabo",
  "Africa/Maputo",
  "Africa/Maseru",
  "Africa/Mbabane",
  "Africa/Mogadishu",
  "Africa/Monrovia",
  "Africa/Nairobi",
  "Africa/Ndjamena",
  "Africa/Niamey",
  "Africa/Nouakchott",
  "Africa/Ouagadougou",
  "Africa/Porto-Novo",
  "Africa/Sao_Tome",
  "Africa/Tripoli",
  "Africa/Tunis",
  "Africa/Windhoek",
  "America/Adak",
  "America/Anchorage",
  "America/Anguilla",
  "America/Antigua",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Aruba",
  "America/Asuncion",
  "America/Atikokan",
  "America/Bahia",
  "America/Bahia_Banderas",
  "America/Barbados",
  "America/Belem",
  "America/Belize",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Bogota",
  "America/Boise",
  "America/Cambridge_Bay",
  "America/Campo_Grande",
  "America/Cancun",
  "America/Caracas",
  "America/Cayenne",
  "America/Cayman",
  "America/Chicago",
  "America/Chihuahua",
  "America/Costa_Rica",
  "America/Creston",
  "America/Cuiaba",
  "America/Curacao",
  "America/Danmarkshavn",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Denver",
  "America/Detroit",
  "America/Dominica",
  "America/Edmonton",
  "America/Eirunepe",
  "America/El_Salvador",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Godthab",
  "America/Goose_Bay",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guatemala",
  "America/Guayaquil",
  "America/Guyana",
  "America/Halifax",
  "America/Havana",
  "America/Hermosillo",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Jamaica",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lima",
  "America/Los_Angeles",
  "America/Lower_Princes",
  "America/Maceio",
  "America/Managua",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Menominee",
  "America/Merida",
  "America/Metlakatla",
  "America/Mexico_City",
  "America/Miquelon",
  "America/Moncton",
  "America/Monterrey",
  "America/Montevideo",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nipigon",
  "America/Nome",
  "America/Noronha",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Ojinaga",
  "America/Panama",
  "America/Pangnirtung",
  "America/Paramaribo",
  "America/Phoenix",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Recife",
  "America/Regina",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Santa_Isabel",
  "America/Santarem",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Sao_Paulo",
  "America/Scoresbysund",
  "America/Sitka",
  "America/St_Barthelemy",
  "America/St_Johns",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Thule",
  "America/Thunder_Bay",
  "America/Tijuana",
  "America/Toronto",
  "America/Tortola",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yakutat",
  "America/Yellowknife",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville",
  "Antarctica/Macquarie",
  "Antarctica/Mawson",
  "Antarctica/McMurdo",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "Arctic/Longyearbyen",
  "Asia/Aden",
  "Asia/Almaty",
  "Asia/Amman",
  "Asia/Anadyr",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Baghdad",
  "Asia/Bahrain",
  "Asia/Baku",
  "Asia/Bangkok",
  "Asia/Beirut",
  "Asia/Bishkek",
  "Asia/Brunei",
  "Asia/Chita",
  "Asia/Choibalsan",
  "Asia/Colombo",
  "Asia/Damascus",
  "Asia/Dhaka",
  "Asia/Dili",
  "Asia/Dubai",
  "Asia/Dushanbe",
  "Asia/Gaza",
  "Asia/Hebron",
  "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong",
  "Asia/Hovd",
  "Asia/Irkutsk",
  "Asia/Jakarta",
  "Asia/Jayapura",
  "Asia/Jerusalem",
  "Asia/Kabul",
  "Asia/Kamchatka",
  "Asia/Karachi",
  "Asia/Kathmandu",
  "Asia/Khandyga",
  "Asia/Kolkata",
  "Asia/Krasnoyarsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Kuwait",
  "Asia/Macau",
  "Asia/Magadan",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Muscat",
  "Asia/Nicosia",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Omsk",
  "Asia/Oral",
  "Asia/Phnom_Penh",
  "Asia/Pontianak",
  "Asia/Pyongyang",
  "Asia/Qatar",
  "Asia/Qyzylorda",
  "Asia/Rangoon",
  "Asia/Riyadh",
  "Asia/Sakhalin",
  "Asia/Samarkand",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Srednekolymsk",
  "Asia/Taipei",
  "Asia/Tashkent",
  "Asia/Tbilisi",
  "Asia/Tehran",
  "Asia/Thimphu",
  "Asia/Tokyo",
  "Asia/Ulaanbaatar",
  "Asia/Urumqi",
  "Asia/Ust-Nera",
  "Asia/Vientiane",
  "Asia/Vladivostok",
  "Asia/Yakutsk",
  "Asia/Yekaterinburg",
  "Asia/Yerevan",
  "Atlantic/Azores",
  "Atlantic/Bermuda",
  "Atlantic/Canary",
  "Atlantic/Cape_Verde",
  "Atlantic/Faroe",
  "Atlantic/Madeira",
  "Atlantic/Reykjavik",
  "Atlantic/South_Georgia",
  "Atlantic/St_Helena",
  "Atlantic/Stanley",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Broken_Hill",
  "Australia/Currie",
  "Australia/Darwin",
  "Australia/Eucla",
  "Australia/Hobart",
  "Australia/Lindeman",
  "Australia/Lord_Howe",
  "Australia/Melbourne",
  "Australia/Perth",
  "Australia/Sydney",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Athens",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Bratislava",
  "Europe/Brussels",
  "Europe/Bucharest",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Chisinau",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/Gibraltar",
  "Europe/Guernsey",
  "Europe/Helsinki",
  "Europe/Isle_of_Man",
  "Europe/Istanbul",
  "Europe/Jersey",
  "Europe/Kaliningrad",
  "Europe/Kiev",
  "Europe/Lisbon",
  "Europe/Ljubljana",
  "Europe/London",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Mariehamn",
  "Europe/Minsk",
  "Europe/Monaco",
  "Europe/Moscow",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Podgorica",
  "Europe/Prague",
  "Europe/Riga",
  "Europe/Rome",
  "Europe/Samara",
  "Europe/San_Marino",
  "Europe/Sarajevo",
  "Europe/Simferopol",
  "Europe/Skopje",
  "Europe/Sofia",
  "Europe/Stockholm",
  "Europe/Tallinn",
  "Europe/Tirane",
  "Europe/Uzhgorod",
  "Europe/Vaduz",
  "Europe/Vatican",
  "Europe/Vienna",
  "Europe/Vilnius",
  "Europe/Volgograd",
  "Europe/Warsaw",
  "Europe/Zagreb",
  "Europe/Zaporozhye",
  "Europe/Zurich",
  "Indian/Antananarivo",
  "Indian/Chagos",
  "Indian/Christmas",
  "Indian/Cocos",
  "Indian/Comoro",
  "Indian/Kerguelen",
  "Indian/Mahe",
  "Indian/Maldives",
  "Indian/Mauritius",
  "Indian/Mayotte",
  "Indian/Reunion",
  "Pacific/Apia",
  "Pacific/Auckland",
  "Pacific/Bougainville",
  "Pacific/Chatham",
  "Pacific/Chuuk",
  "Pacific/Easter",
  "Pacific/Efate",
  "Pacific/Enderbury",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Funafuti",
  "Pacific/Galapagos",
  "Pacific/Gambier",
  "Pacific/Guadalcanal",
  "Pacific/Guam",
  "Pacific/Honolulu",
  "Pacific/Johnston",
  "Pacific/Kiritimati",
  "Pacific/Kosrae",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Marquesas",
  "Pacific/Midway",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Norfolk",
  "Pacific/Noumea",
  "Pacific/Pago_Pago",
  "Pacific/Palau",
  "Pacific/Pitcairn",
  "Pacific/Pohnpei",
  "Pacific/Port_Moresby",
  "Pacific/Rarotonga",
  "Pacific/Saipan",
  "Pacific/Tahiti",
  "Pacific/Tarawa",
  "Pacific/Tongatapu",
  "Pacific/Wake",
  "Pacific/Wallis"
}

export interface KioskDTO {
  capabilities: Record<"interactive_desktop_sharing", boolean>;
  device_id: string;
  display_name: string;
  endpoint_status: EndpointStatusDTO;
  ip_addresses: string[];
  ipip_printer_address: string;
  ipip_printer_enabled: boolean;
  ipip_printer_model: string;
  languages: [];
  location: string;
  name: string;
  time_zone: Timezone;
}

export interface ExpertDTO {
  capabilities: Record<"interactive_desktop_sharing", boolean>;
  details: string;
  device_id: string;
  display_name: string;
  endpoint_status: EndpointStatusDTO;
  extension: string;
  id: string;
  ip_addresses: string[];
  languages: [];
  last_topic: string;
  load: number;
  location: string;
  mustang_extension: string;
  name: string;
  status: ClientStatus;
  time_zone: Timezone;
  topics: [];
}

export interface WebexAccessToken {
  token_string: string;
  expires: number;
}

export type BaseConfig = {
  dcmServiceUrl?: string;
  inboxServiceUrl?: string;
  inboxServiceFileStorageUrl?: string;
  clientName?: string;
  clientPassword?: string;
  wbdServiceUrl?: string;
  clientType?: "kiosk" | "expert";
  envMode?: "staging" | "development" | "production";
};

export type Config = BaseConfig & Record<string, string>;

export type RecordingParams = {
  destinationUrl: string;
  screenEnabled: boolean;
  screenResolution: number;
  screenFrameRate: number;
  screenBitRate: number;
  speakersEnabled: boolean;
  speakersBitRate: number;
  microphoneEnabled: number;
  microphoneBitRate: number;
};

export type ServiceConfig = BaseConfig & {
  dcmServicePort?: number;
  remServiceUrl?: string;
  remServicePort?: number;
  wmsServiceUrl?: string;
  wmsServicePort?: number;
  tmsServiceUrl?: string;
  clientId?: string;
  clientDisplayName?: string;
  wbdServiceUrl?: string;
  stagingRequestDuration?: number;
  extension?: string;
  mustangExtension?: string;
  jwt?: string;
  webexAccessToken?: string;
  webexClientId?: string;
  webexRedirectUri?: string;
  webexScope?: string;
  webexWithoutLoginInitialization?: boolean;
  timezone?: Timezone;
  telephonyType?: TelephonyType;
  agentServiceKey?: string;
  agentServicePort?: number;
  recordingParams?: RecordingParams;
  awsS3BucketName?: string;
  awsAccessKeyId?: string;
  awsSecretAccessKey?: string;
  awsRegion?: string;
};

export interface RpcRequest {
  isPrioritized?: boolean;
  method: string;
  jwt?: string;
  host: string;
  headers?: Record<string, string | number>;
  body?: any;
  callback: Function;
  errorCallback?: Function;
}

export interface SessionInfo {
  // eslint-disable-next-line @typescript-eslint/camelcase
  client_id: string;
  extension: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  ip_addresses: string[];
  status: number;
  topic: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  endpoint_status: EndpointStatusDTO;
  // eslint-disable-next-line @typescript-eslint/camelcase
  companion_endpoint_status: EndpointStatusDTO;
  // eslint-disable-next-line @typescript-eslint/camelcase
  companion_endpoint_status_code: EndpointStatus;
  // eslint-disable-next-line @typescript-eslint/camelcase
  client_context: object;
}

export enum RemSignal {
  answerRequested = "answer_requested",
  positionChanged = "position_changed",
  callRequested = "call_requested",
  twilioJoinRequested = "join_requested",
  twilioLeaveRequested = "leave_requested",
  hangupRequested = "hangup_requested",
  membershipRequested = "membership_requested",
  message = "message",
  resultReady = "result_ready",
  endpointStatusChanged = "endpoint_status_changed",
  statusChanged = "status_changed",
  recvFrom = "recv_from",
  holdRequested = "hold_requested",
  shutdownRequested = "shutdown_requested",
  sessionInfoChanged = "session_info_changed",
  availableTopicsChanged = "available_topics_changed",
  incidentChanged = "incident_changed",
  ticketsCountChanged = "tickets_count_changed"
}

export enum MessageType {
  fileSharingStart = 2,
  fileSharingStop = 3,
  rdcDesktopSharingStart = 101,
  rdcDesktopSharingStop = 102,
  desktopSharingStart = 103,
  desktopSharingStop = 104,
  desktopSharingAnswerReady = 105,
  desktopSharingIceCandidate = 106,
  desktopSharingHintsChanged = 107,
  desktopSharingTrustedModeExitConsentAcquired = 108,
  presentableInfo = 201,
  screenResolution = 202,
  aspectRatio = 203,
  microphones = 206,
  selfViewShown = 207,
  selfViewHidden = 208,
  layouts = 209,
  accessibilityMode = 210,
  awsTranslationFinished = 211,
  awsTranslationTargetLanguage = 212,
  actionSendFile = 300,
  actionVideoChatNextCamera = 301,
  actionVideoChatEnableCamera = 302,
  actionVideoChatDisableCamera = 303,
  actionSendSignature = 304,
  actionCancelSignature = 305,
  actionSendTextMessage = 306,
  actionSendCallInviteLink = 307,
  actionChangeAspectRatio = 308,
  actionVideoChatSetMicrophone = 309,
  actionScreenSharingStart = 310,
  actionScreenSharingStop = 311,
  actionSelfViewShow = 312,
  actionSelfViewHide = 313,
  actionGeolocationSharingStart = 314,
  actionGeolocationSharingStop = 315,
  actionSetLayout = 316,
  actionSetAccessibilityMode = 317
}

export enum FunctionalAvailabilityPropertyName {
  tilesDesktopSharingEnabled = "tiles.desktop.sharing.enabled",
  tilesFileSharingEnabled = "tiles.file.sharing.enabled",
  callTransferEnabled = "call.transfer.enabled",
  topicTransferEnabled = "topic.transfer.enabled",
  tilesKioskMicVolumeEnabled = "tiles.kiosk.mic.volume.enabled",
  tilesKioskSpeakerVolumeEnabled = "tiles.kiosk.speaker.volume.enabled",
  tilesCustomerInfoFormEnabled = "tiles.customer.info.form.enabled",
  tilesSmsEnabled = "tiles.sms.enabled",
  tilesEmailInboxEnabled = "tiles.email.inbox.enabled",
  tilesHelpdeskEnabled = "tiles.helpdesk.enabled",
  tilesSurveyEnabled = "tiles.survey.enabled",
  tilesVisualHintsEnabled = "tiles.visual.hints.enabled",
  tilesQrCodeEnabled = "tiles.qrcode.enabled",
  messagingPanelEnabled = "messaging_panel_enabled", // for text hints
  tilesSurveillanceEnabled = "tiles.surveillance.enabled", // for kiosk monitoring
  tilesDocumentCameraEnabled = "tiles.document.camera.enabled",
  tilesBarcodeScannerEnabled = "tiles.barcode.scanner.enabled",
  customerDocumentSaveEnabled = "customer.document.save.enabled",
  surveillanceCameraEnabled = "surveillance.camera.enabled",
  surveillanceScreenEnabled = "surveillance.screen.enabled",
  tilesSignaturePadEnabled = "tiles.signature.pad.enabled",
  tilesRemoteViewEnabled = "tiles.remote.view.enabled",
  agentServiceEnabled = "agent.service.enabled",
  usbIpEnabled = "usbip.enabled",
  ipIpEnabled = "ipip.enabled",
  ipIpPrintersEnabled = "ipip.printers.enabled",
  tcpPrintersEnabled = "tcp.printers.enabled",
  virtualBackgroundEnabled = "virtual.background.enabled",
  vpnEnabled = "vpn.enabled"
}
export enum RecordingParamPropertyName {
  destination = "recording.destination",
  screenEnabled = "recording.screen.enabled",
  screenResolution = "recording.screen.resolution",
  screenFrameRate = "recording.screen.frame.rate",
  screenBitRate = "recording.screen.bit.rate",
  speakersEnabled = "recording.speakers.enabled",
  speakersBitRate = "recording.speakers.bit.rate",
  microphoneEnabled = "recording.microphone.enabled",
  microphoneBitRate = "recording.microphone.bit.rate"
}

export enum CallQueuePositionChangedReason {
  unknown, ///< Unknown reason
  advanced, ///< Position in the queue has advanced
  released, ///< Position released by the Kiosk
  sessionStarted, ///< Session started
  noExperts, ///< No experts available
  noTopic, ///< Topic is no longer available
  timeout ///< Waiting for an expert too long
}

export interface WebexRoom {
  created: string;
  creatorId: string;
  id: string;
  isLocked: boolean;
  lastActivity: string;
  ownerId: string;
  title: string;
  type: string;
}

export interface WebexPerson {
  created: string;
  displayName: string;
  emails: string[];
  firstName: string;
  id: string;
  lastActivity: string;
  lastName: string;
  nickName: string;
  orgId: string;
  phoneNumbers: string[];
  status: string;
  type: string;
}

export interface WebexMedia {
  type: string;
  stream: MediaStream;
}

export interface WebexMeetingAttributes {
  deviceUrl: string;
  orgId: string;
  userId: string;
  [k: string]: unknown;
}

export interface WebexMeetingMember {
  associatedUser: boolean;
  id: string;
  isAudioMuted: boolean;
  isContentSharing: boolean;
  isDevice: boolean;
  isGuest: boolean;
  isHost: boolean;
  isInLobby: boolean;
  isInMeeting: boolean;
  isModerator: boolean;
  isModeratorAssignmentProhibited: unknown;
  isMutable: boolean;
  isNotAdmitted: boolean;
  isRecording: boolean;
  isRemovable: boolean;
  isSelf: boolean;
  isUser: boolean;
  isVideoMuted: boolean;
  name: string;
  namespace: string;
  participant: object;
  status: "NOT_IN_MEETING" | "IN_MEETING" | "IN_LOBBY";
  type: string;
}

export interface WebexMeeting {
  admit: Function;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  acknowledge(type: string): Promise<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addMedia(params: unknown): Promise<any>;
  attrs: WebexMeetingAttributes;
  audio: {
    muted: boolean;
    self: boolean;
    [k: string]: unknown;
  };
  callEvents: string[];
  canUpdateMedia(): boolean;
  conversationUrl: string;
  correlationId: string;
  creator: boolean;
  deviceUrl: string;
  floorGrantPending: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMediaStreams(
    mediaSettings: unknown,
    audioVideoOptions?: object
  ): Promise<[MediaStream, MediaStream]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSupportedDevices(params: unknown): Promise<any>;
  guest: boolean;
  hostId: string;
  id: string;
  inMeetingActions: {
    canAssignHost: boolean;
    canLock: boolean;
    canUnlock: boolean;
    namespace: string;
  };
  isLocked: boolean;
  isSharing: boolean;
  isUnlocked: boolean;
  join(): Promise<unknown>;
  joinedWith: {
    availableLayouts: string[];
    callLegId: string;
    correlationId: string;
    csis: number[];
    deviceType: string;
    isVideoCallback: boolean;
    keepAliveSecs: number;
    keepAliveUrl: string;
    serverComposed: boolean;
    serverTranscoded: boolean;
    state: string;
    url: string;
  };
  leave(): Promise<unknown>;
  locked: boolean;
  locusId: string;
  locusUrl: string;
  mediaId: string;
  mediaProperties: {
    audioTrack?: MediaStreamTrack;
    mediaDirection: {
      pstn: boolean;
      receiveAudio: boolean;
      receiveShare: boolean;
      receiveVideo: boolean;
      sendAudio: boolean;
      sendShare: boolean;
      sendVideo: boolean;
    };
    mediaSettings: {
      audio: {
        echoCancellation: boolean;
        noiseSuppression: boolean;
      };
      video: {
        aspectRatio: number;
        frameRate: number;
        height: number;
        width: number;
      };
    };
    namespace: string;
    peerConnection: RTCPeerConnection;
    remoteAudioTrack?: MediaStreamTrack;
    remoteQualityLevel: string;
    remoteVideoTrack?: MediaStreamTrack;
    shareTrack?: MediaStreamTrack;
    videoDeviceId: string;
    videoTrack?: MediaStreamTrack;
  };
  mediaQualityMetrics: unknown;
  mediaStatus: {
    audio: string;
    slides: string;
    video: string;
  };
  meetingInfo: {
    audioType: string;
    conversationUrl: string;
    dialingIPAddress: string;
    displayMeetingUrl: string;
    enableShortUri: boolean;
    globalMeetingId: string;
    isCallInEnabled: boolean;
    isPmr: boolean;
    isSparkPstnEnabled: false;
    localDialInNumber: {
      number: string;
      tollfree: boolean;
      label: string;
      tapToJoin: string;
    };
    locusCallUrl: string;
    locusUrl: string;
    maxParticipants: number;
    meetingLink: string;
    meetingName: string;
    meetingNumber: string;
    numericCode: string;
    owner: string;
    sipMeetingUri: string;
    skypeUri: string;
    sponsor: string;
    supportCallback: boolean;
    supportCrossLaunch: boolean;
    supportGlobalCallback: boolean;
    supportGlobalCallin: boolean;
    supportInternalCallback: boolean;
    uri: string;
    webExMeetingLink: string;
    webExRosterSyncEnabled: boolean;
    webExSite: string;
  };
  meetingRequest: {
    ready: boolean;
  };
  meetingState: string;
  members: {
    hostId: string;
    locusUrl: string;
    membersCollection: { members: Record<string, WebexMeetingMember> };
    on(eventName: string, callback: unknown): void;
    selfId: string;
    type: string;
  };
  moderator: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ADD_GUEST: boolean;
    EXPEL: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MUTE_ALL: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MUTE_OTHER: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PRESENTER_CONTROL: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    RECORDING_CONTROL_START: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SHARE_CONTROL: boolean;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UNMUTE_ALL: boolean;
  };
  muted: boolean;
  namespace: string;
  networkStatus: string;
  on(eventName: string, callback: unknown): void;
  orgId: string;
  owner: string;
  ready: boolean;
  removeAllListeners(eventName: string): void;
  selfId: string;
  selfIdentity: string;
  selfUrl: string;
  sipUri: string;
  state: string;
  type: string;
  updateShare(params: unknown): Promise<unknown>;
  userId: string;
  invite(
    invitee: { emailAddress: string },
    alertIfActive?: boolean
  ): Promise<unknown>;
  isVideoMuted: () => boolean;
  isAudioMuted: () => boolean;
  muteVideo: () => Promise<unknown>;
  muteAudio: () => Promise<unknown>;
  unmuteVideo: () => Promise<unknown>;
  unmuteAudio: () => Promise<unknown>;
  mute: (participantID: string, mute: boolean) => Promise<unknown>;
  getDevices: () => Promise<MediaDeviceInfo[]>;
  updateVideo: (params: {
    sendVideo: boolean;
    receiveVideo: boolean;
    stream: MediaStream;
  }) => unknown;
  updateAudio: (params: {
    sendAudio: boolean;
    receiveAudio: boolean;
    stream: MediaStream;
  }) => unknown;
}

export interface WebexStateData {
  webex?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  meeting?: WebexMeeting;
  errorMessage?: string;
  isShareReceiving?: boolean;
}

export interface WebexState {
  data?: WebexStateData;

  patchData?(data: Partial<WebexStateData>): void;
}

export enum TelephonyType {
  unknown = -1,
  cucm,
  webex,
  twilio
}

export type MailCollectionDTO = {
  from: [string, string];
  subject: string;
  timestamp: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  read_status: "True" | "False";
  // eslint-disable-next-line @typescript-eslint/camelcase
  attachments_count: number;
}[];

export type MailDTO = {
  from: [string, string];
  subject: string;
  timestamp: string;
  message: string;
  attachments: {
    name: string;
    size: number;
  }[];
};

export type RoomDTO = {
  // eslint-disable-next-line @typescript-eslint/camelcase
  creation_time: number;
  description: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  expert: { device_id: string; id: string; is_connected: boolean };
  id: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  idle_time: number;
  // eslint-disable-next-line @typescript-eslint/camelcase
  joined_clients: {
    // eslint-disable-next-line @typescript-eslint/camelcase
    device_id: string;
    id: string;
    // eslint-disable-next-line @typescript-eslint/camelcase
    is_connected: boolean;
    // eslint-disable-next-line @typescript-eslint/camelcase
    connection_lost: boolean;
  }[];
  lifetime: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  taken_at: number;
  topic: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  is_active?: boolean;
};

export type Survey = {
  sources: {
    type: "screen" | "camera";
    name?: string;
    index: number;
  }[];
  controlInfo?: {
    tracks: {
      // eslint-disable-next-line @typescript-eslint/camelcase
      zoom_available: boolean;
      // eslint-disable-next-line @typescript-eslint/camelcase
      laser_available: boolean;
      error?: string;
    }[];
  };
  connectionConfig?: RTCConfiguration;
  connectionId: string;
  deviceId: string;
  isDataChannelReady: boolean;
  peer?: any;
  streams?: MediaStream[];
  errorMessage?: string;
  snapshots: string[];
};

export type IceCandidateDTO = {
  candidate: string;
  sdpMid: string;
  sdpMLineIdx?: number;
};

export type VisualHintDTO = {
  url: string;
  duration: number;
  position: "left" | "right";
};

export type QrCodeDTO = {
  text: string;
  duration: number;
  position?: "left" | "right";
};

export type UsbIpDeviceDTO = {
  // eslint-disable-next-line @typescript-eslint/camelcase
  bus_address: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  product_id: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  vendor_id: string;
};

export enum RequestedAction {
  sendFile,
  videoChatNextCamera,
  videoChatEnableCamera,
  videoChatDisableCamera,
  videoChatSetMicrophone,
  sendSignature,
  cancelSignature,
  sendTextMessage,
  sendCallInviteLink,
  changeAspectRatio,
  screenSharingStart,
  screenSharingStop,
  selfViewShow,
  selfViewHide,
  geolocationSharingStart,
  geolocationSharingStop,
  setLayout,
  setAccessibilityMode
}

export enum ServiceDefaultPort {
  dcm = 8181,
  rem = 8888,
  wms = 8228,
  tms = 8585,
  agent = 4539
}

export enum DeviceType {
  desktop,
  mobile,
  tablet
}

export enum StatisticMode {
  disabled,
  audioOnly,
  videoOnly,
  audioAndVideo
}

export enum AspectRatioMode {
  cover,
  contain
}

export type VirtualBackgroundConfig = {
  enabled: boolean;
  segmentation_mode: "ai" | "chromakey";
  source_camera_name: string;
  virtual_camera_name: string;
};

export type DesktopSourceDTO = {
  id: string;
  type: "window" | "entire_desktop";
  title: string;
  thumbnail:
    | {
        width: number;
        height: number;
        data: string;
      }
    | { error: string };
};

export enum IncidentType {
  none = -1,
  queueTimeout,
  noExperts
}

export type IncidentDTO = {
  id: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  created_at: number;
  topic: string;
  type: IncidentType;
  // eslint-disable-next-line @typescript-eslint/camelcase
  in_process: true;
};

export type TicketDTO = {
  id: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  incident_payload: object;
};

export enum ScreenSharingDialogTab {
  undefined,
  browser,
  window,
  monitor
}

export enum AwsLanguage {
  "en-US",
  "en-GB",
  "en-AU",
  "zh-CN",
  "fr-FR",
  "fr-CA",
  "hi-IN",
  "de-DE",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "pt-BR",
  "es-MX",
  "th-TH",
  "ar-SA",
  "cs-CZ",
  "da-DK",
  "el-GR",
  "en-IN",
  "en-NZ",
  "en-ZA",
  "es-ES",
  "fi-FI",
  "he-IL",
  "hu-HU",
  "id-ID",
  "nl-NL",
  "no-NO",
  "pl-PL",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "sk-SK",
  "sv-SE",
  "ta-IN",
  "tr-TR",
  "zh-HK",
  "ca-ES",
  "ar-AE",
  "cy-WL",
  "en-WL",
  "is-IS",
  af,
  sq,
  am,
  hy,
  az,
  bn,
  bs,
  bg,
  hr,
  "fa-AF",
  et,
  fa,
  tl,
  ka,
  gu,
  ht,
  ha,
  ga,
  kk,
  lv,
  lt,
  mk,
  ms,
  ml,
  mt,
  mr,
  mn,
  ps,
  pa,
  sr,
  si,
  sl,
  so,
  sw,
  te,
  uk,
  ur,
  uz,
  vi
}
export enum ColibriLanguage {
  Any = 0,
  Arabic = 8,
  Chinese = 25,
  English = 31,
  French = 37,
  German = 42,
  Hebrew = 48,
  Italian = 58,
  Japanese = 59,
  Korean = 66,
  Portuguese = 91,
  Russian = 96,
  Spanish = 111
}
